import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import MySubscriptions from "../../components/dashboard/dashboardPartials/MySubscriptions";
import MyOrders from "../../components/dashboard/dashboardPartials/MyOrders";
import OrderDetails from "../../components/dashboard/orderPartials/OrderDetails";
import { useEffect, useState } from "react";
import { useGeneral } from "../../components/contexts/GeneralContext";
import { useParams } from "react-router-dom";
import axios from "../../config/axios";
import ApiErrorMessage from "../../components/common/ApiErrorMessage";
import NoItemsFound from "../../components/common/NoItemsFound";
import FullScreenLoading from "../../components/common/loading/FullScreenLoading";
const usePageContent = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState([]);
  const [error, setError] = useState("");
  const { discountCoupons } = useGeneral();
  const { id } = useParams();
  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const { data } = await axios.get(`/dashboard/orders/${id}`);

        if (active) setContent(data?.items);
      } catch (err) {
        console.error(err);
        if (active) setError("Failed to load plans. Please try again later.");
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return { content, loading, error, discountCoupons };
};

const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};
const OrderDetailsPage = () => {
  const { content, loading, error, discountCoupons } = usePageContent();
  useScrollToTop();

  return (
    <>
      {loading && <FullScreenLoading />}
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />

        <BodyWrapper className="mb-0 xl:mb-0">
          <Wrapper
            goBack={true}
            component={
              !loading && error ? (
                <ApiErrorMessage
                  message1="Failed to load order details"
                  message2="Please check your connection and try again."
                />
              ) : !loading && !content ? (
                <NoItemsFound
                  message1="Order details unavailable"
                  message2="Please check back later."
                />
              ) : (
                !loading && content && <OrderDetails order={content} />
              )
            }
          />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default OrderDetailsPage;
